/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UtilityComponentsModule } from 'src/app/common/utility-components/utility-components.module';
import { MaterialModule } from 'src/app/common/material/material-module';
import { CustomFieldStarterComponent } from './components/custom-field-starter.component';
import { AddEditCustomFieldComponent } from './components/add-edit-custom-field.component';
import { CustomFieldEditorComponent } from './components/custom-field-editor.component';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { CustomFieldService } from './services/custom-field.services';
import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';
import { CustomFieldSharedModule } from './custom-field-shared.module';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';

@NgModule({
	declarations: [CustomFieldEditorComponent, CustomFieldStarterComponent, AddEditCustomFieldComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		UtilityComponentsModule,
		DialogReusableModule,
		SharedUIMaterialModule,
		CustomFieldSharedModule,
		PresentationModule,
	],
	providers: [CustomFieldService],
	exports: [CustomFieldSharedModule, CustomFieldStarterComponent, AddEditCustomFieldComponent],
})
export class CustomFieldModule {}
